import { services } from '../../../mocks/services';

export default function ServicesSection() {
  return (
    <section id="services" className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-12 lg:mb-16">
          <span className="inline-block bg-orange-100 text-orange-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Our Services
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-4">
            Everything Your Property Needs To Shine
          </h2>
          <p className="text-slate-500 text-lg max-w-xl">
            Professional cleaning solutions across South Florida that protect, restore, and add value to your home.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <article
              key={service.id}
              className="group border border-gray-200 rounded-2xl overflow-hidden bg-white hover:border-teal-400 transition-colors cursor-pointer"
            >
              {/* Service Image */}
              <div className="relative h-48 overflow-hidden bg-slate-100">
                <img
                  src={service.imageUrl}
                  alt={`${service.name} South Florida`}
                  title={`Professional ${service.name} service near me`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-teal-600">
                    <i className={`${service.icon} text-white text-base`}></i>
                  </div>
                  <span className="text-white font-bold text-sm">{service.name}</span>
                </div>
                {index === 0 && (
                  <div className="absolute top-3 right-3 bg-orange-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                    Most Popular
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="p-5">
                <p className="text-teal-700 font-semibold text-sm mb-2 flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                    <i className="ri-check-double-line text-teal-600 text-sm"></i>
                  </div>
                  {service.benefit}
                </p>
                <p className="text-slate-500 text-sm leading-relaxed mb-5">{service.description}</p>
                <a
                  href="#contact"
                  className="flex items-center justify-between bg-slate-50 hover:bg-teal-600 group-hover:bg-teal-600 text-slate-700 hover:text-white group-hover:text-white font-bold text-sm px-4 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span>Get Quote for {service.name}</span>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-base"></i>
                  </div>
                </a>
              </div>
            </article>
          ))}

          {/* Bonus card: All Services */}
          <article className="border-2 border-dashed border-teal-300 rounded-2xl p-6 flex flex-col items-center justify-center text-center bg-teal-50 sm:col-span-2 lg:col-span-1">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-teal-100 mb-4">
              <i className="ri-home-smile-2-line text-teal-600 text-2xl"></i>
            </div>
            <h3 className="text-slate-800 font-black text-lg mb-2">Not Sure What You Need?</h3>
            <p className="text-slate-500 text-sm mb-5">
              We'll assess your property and recommend exactly what it needs — no upsells, no pressure.
            </p>
            <a
              href="#contact"
              className="bg-teal-600 hover:bg-teal-700 text-white font-bold px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              Request Free Assessment
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}
